import type { IntlShape } from 'react-intl'

export function generateStaticMonthCaptions(
  intl: IntlShape,
  currency: string,
  dayPrices?: { [isoDate: string]: App.Property.CalendarDay } | undefined,
): { [isoYearMonth: string]: React.ReactNode } | undefined {
  if (!dayPrices) return
  const caption = intl.formatMessage({
    id: 'R0fAzMEHL-DJLClatpXI',
    defaultMessage: 'Approximate nightly price in {currency} for a 1 night stay, 2 adults, select dates and click “Apply” to see live prices.',
    description: 'Caption under a calendar month with prices, saying the amounts are approximate 1 night prices for 2 adults in the shown currency code',
  }, { currency })
  const isoYearMonthsWithPrices = [...new Set(Object.keys(dayPrices).map((isoDate) => isoDate.slice(0, 7)))]
  return Object.fromEntries(isoYearMonthsWithPrices.map((isoYearMonth) => [isoYearMonth, caption]))
}
